module.exports = __webpack_public_path__ + "static/media/prorroga.1655f722.jpg";